import styled from 'styled-components';

import { colors, breakpoints, fontFamily } from '../../ui/variables';

export const UsersListStyle = styled.div`
  width: 100%;
  margin-top: 38px;
  padding: 0 20px;
  min-width: 200px;

  .users-list-table-head {
    display: none;
    @media (min-width: ${breakpoints.ipadLandscape.width}px) {
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
    }

    .table-head-item {
      justify-content: left;
      margin-bottom: 10px;

      &.name-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 20%;
          min-width: 20%;
          padding-left: 12px;
        }
      }

      &.matriculation-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 11%;
          min-width: 11%;
          margin-right: 2%;
        }
      }

      &.role-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 10%;
          min-width: 10%;
        }
      }

      &.registration-date-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 13%;
          min-width: 13%;
        }
      }

      &.patient-data-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 10%;
          min-width: 10%;
        }
      }

      &.images-exams-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 12%;
          min-width: 12%;
        }
      }

      &.report-results-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 11%;
          min-width: 11%;
        }
      }

      &.actions-item {
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          max-width: 18%;
          min-width: 18%;
          padding-left: 12px;
        }
      }
    }
  }

  .users-list-data {
    width: 100%;
    min-width: 200px;
    .user-list-item {
      margin-bottom: 8px;
      position: relative;
      width: 100%;
      height: 110px;
      padding-left: 30px;
      background-color: ${colors.mostlyWhite};
      border-radius: 19px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media (min-width: ${breakpoints.ipadLandscape.width}px) {
        display: table;
        height: 81px;
        padding-left: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }

      .user-list-item-data {
        justify-content: left;
        display: table-cell;
        vertical-align: middle;
        margin-bottom: 3px;

        .option-container {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-bottom: 16px;
          margin-top: 10px;

          .text-permission {
            font-size: 14px;
          }

          .check-box {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-right: 16px;

            .box {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              height: 28px;
              width: 28px;
              background-color: white;
              border-radius: 6px;
              svg {
                fill: ${colors.limeGreen};
                width: 20px;
                height: 15px;
              }
            }
          }
        }

        &.name-list-item {
          /* ${fontFamily.sourceSansPro.bold};
          word-break: break-all; */
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 18%;
            min-width: 18%;
            padding-left: 12px;
            margin-right: 2%;
          }
        }

        &.matriculation-list-item {
          display: none;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: table-cell;
            max-width: 13%;
            min-width: 13%;
          }
        }

        &.role-list-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 12%;
            min-width: 12%;
          }
        }

        &.registration-date-list-item {
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            max-width: 14%;
            min-width: 14%;
          }
        }

        &.patient-data-list-item {
          display: none;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: table-cell;
            max-width: 10%;
            min-width: 10%;
          }
        }

        &.images-exams-list-item {
          display: none;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: table-cell;
            max-width: 12%;
            min-width: 12%;
          }
        }

        &.report-results-list-item {
          display: none;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            display: table-cell;
            max-width: 10%;
            min-width: 10%;
          }
        }

        &.actions-list-item {
          position: absolute;
          bottom: 24px;
          right: 34px;
          @media (min-width: ${breakpoints.ipadLandscape.width}px) {
            top: 0;
            right: 0;
            position: relative;
            width: 80px;
            height: 100%;
          }
          .actions-item {
            width: 80px;
            display: flex;
            justify-content: space-around;
            svg {
              height: 20px;
              width: 20px;
              fill: #95a1b4;
            }
            @media (min-width: ${breakpoints.ipadLandscape.width}px) {
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
            }
          }
        }
      }

      .go-to-user-text {
        font-size: 10px;
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.softBlue};
        position: absolute;
        top: 14px;
        right: 34px;
        @media (min-width: ${breakpoints.ipadLandscape.width}px) {
          display: none;
        }
      }
    }
  }
`;
